import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { updateNewProduct } from "../../features/product/productSlice";
import { Product } from "../../types/product";
import { useMasterData } from "../api/useMasterData";

export function useInitializeProductForm( typeModal: string | null, selectedProduct: Product | null, ) {
    
    const { 
        getCategory: allCategories, 
        isErrorGetCategory: isErrorCategories, 
        isLoadingGetCategory: isLoadingAllCategories, 
        errorGetCategory: errorAllCategories,
        getSizes: sizesAvailable,
        isErrorGetSizes: isErrorGetSizes,
        errorGetSizes: errorAllSizes,
        isLoadingGetSizes: isLoadingGetSizes
    } = useMasterData()
    const dispatch = useDispatch();
    const hasInitialized = useRef(false);
    useEffect(() => {
        if (hasInitialized.current) return;

        if (
            typeModal === "updateProduct" &&
            selectedProduct &&
            allCategories.length > 0 &&
            sizesAvailable.length > 0
        ) {
            const matchedCategory = allCategories.find(
                (cat) =>
                    cat.categoryName ===
                    selectedProduct.categoryInfo.categoryName
            );

            const matchedSize = sizesAvailable.find(
                (size) =>
                    size.size === selectedProduct.sizeInfo.size
            );

            dispatch(
                updateNewProduct({
                    category: matchedCategory
                        ?   {
                                id: matchedCategory.categoryID,
                                label: matchedCategory.categoryName,
                            }
                        : null,
                    productName: selectedProduct.productName || "",
                    description: selectedProduct.description || "",
                    price: selectedProduct.price || 0,
                    size: matchedSize
                        ?   {
                                id: matchedSize.sizeId,
                                label: matchedSize.size,
                            }
                        : null,
                    image: selectedProduct.image,
                    isAvailable: selectedProduct.isAvailable,
                })
            );

            hasInitialized.current = true;
        }

        if (typeModal === "newProduct") {
            dispatch(
                updateNewProduct({
                    category: null,
                    productName: "",
                    description: "",
                    price: 0,
                    size: null,
                    image: "",
                    isAvailable: false,
                })
            );

            hasInitialized.current = true;
        }
    }, [typeModal, selectedProduct, allCategories, sizesAvailable, dispatch]);

    return {
        allCategories,
        sizesAvailable,
        isLoadingAllCategories,
        isLoadingGetSizes,
        isErrorCategories,
        isErrorGetSizes,
        errorAllCategories,
        errorAllSizes
    };
}